import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Result } from '@model/iceberg/deal-finder/deal-finder';
import { ResultsGrid } from '@components/search-results/deal-finder-results/results-grid/ResultsGrid';
import { loadMore } from '@state/search-results/from-price-packages/fromPricePackagesOperations';
import { FromPriceProductTile } from '@components/common/product-tile/from';
import {
  getFromPricePackages,
  getHasFromPricePackages,
  getFromPricePackagesLoading,
  getFromPricePackageHasMore
} from '@state/search-results/from-price-packages/fromPricePackagesSelectors';
import { NoResults } from '@components/common/no-results/NoResults';
import { Icons } from '@model/common/icons';
import { OfferType } from '@model/offers/offers';

export interface FromPriceResultsContainerProps {
  onResetFilters: () => void;
  offerType: OfferType;
}

export const FromPriceResultsContainer = ({ onResetFilters, offerType }: FromPriceResultsContainerProps) => {
  const dispatch = useDispatch();
  const handleOnLoadMore = () => dispatch(loadMore());
  const results = useSelector(getFromPricePackages);
  const hasPackages = useSelector(getHasFromPricePackages);
  const isLoading = useSelector(getFromPricePackagesLoading);
  const isMoreAvailable = useSelector(getFromPricePackageHasMore);
  const renderTile = (productPackage: Result) => (
    <FromPriceProductTile productPackage={productPackage} offerType={offerType} />
  );

  return (
    <>
      {!hasPackages && (
        <NoResults
          label={'search-results__filters-no-results--title'}
          onClick={onResetFilters}
          icon={Icons.SEARCH}
          link={'search-results__filters-no-results--link'}
        />
      )}
      <ResultsGrid
        packages={results || []}
        isLoadingMore={isLoading}
        renderTile={renderTile}
        onLoadMore={handleOnLoadMore}
        isMoreAvailable={isMoreAvailable}
      />
    </>
  );
};
